export default __webpack_public_path__ + "static/ad-ro-e20747c0c6287f708b93a0184a5edb9f.png";